import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import NWLMap from '../../components/NWL/Map/Map';
import Kpi from '../../components/NWL/KPI/Kpi';
import RainRate from '../../components/NWL/RainRate/RainRate';
import AssetInfo from '../../components/NWL/AssetInfo/AssetInfo';
import PlayBar from '../../components/NWL/PlayBar';
import { DashboardContext, NWLContext } from '../../contexts';
import { getInfraestructuresByLocation } from '../../services/measurement';
import { getLinksMinify } from '../../services/links';
import Navbar, { defaultLayerState } from '../../components/NWL/Navbar/Navbar';
import { useNavigate } from 'react-router-dom';
import ControlZoom from '../../components/NWL/ControlZoom';
import IconLegend from '../../components/NWL/IconLegend/IconLegend';
import ComparisonGraph from '../../components/NWL/ComparisonGraph';
import { getSites } from '@/services/sitePredictions';
import { getMapAssets } from '@/services/assets';
import { useActiveLocationId, setActiveLocationId } from '../../components/utils/activeLocation';
import { getLocationCoords } from '@/services/getLocations';
import { FlyToInterpolator } from '@deck.gl/core';

import './styles.scss';
import dayjs from 'dayjs';

const weatherOverlayKey = [
	{ value: '50mm', rgba: [221, 252, 254, 1] },
	{ value: '', rgba: [252, 7, 253, 1] },
	{ value: '7mm', rgba: [248, 10, 8, 1] },
	{ value: '', rgba: [252, 141, 8, 1] },
	{ value: '2mm', rgba: [251, 195, 7, 1] },
	{ value: '', rgba: [115, 116, 0, 1] },
	{ value: '', rgba: [86, 142, 254, 1] },
	{ value: '0.36mm', rgba: [0, 0, 254, 1] },
	{ value: '0mm', rgba: [0, 0, 0, 0] },
];

const DEFAULT_VIEW_STATE = {
	longitude: Number(process.env.VITE_MAP_INIT_LONGITUDE) || -1.447519,
	latitude: Number(process.env.VITE_MAP_INIT_LATITUDE) || 55.031679,
	zoom: 10,
	pitch: 0,
	bearing: 0,
};

const RefreshNotice = ({ onRefresh, disabled }) => {
	return (
		<div className="refresh-notice" role="status" aria-live="polite">
			<div aria-hidden="true">
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M16.4355 12.0068C17.3532 11.9961 18.2577 12.2258 19.0586 12.6738C19.8594 13.1218 20.5289 13.7721 21 14.5596V12.75H22.5V17.25H18V15.75H19.9326C19.6621 15.1302 19.2285 14.595 18.6787 14.2012C18.1289 13.8074 17.4825 13.5702 16.8086 13.5137C16.1348 13.4572 15.4583 13.5833 14.8506 13.8799C14.2428 14.1765 13.7265 14.6322 13.3564 15.1982C12.9864 15.7643 12.7759 16.42 12.748 17.0957C12.7202 17.7712 12.8762 18.4416 13.1982 19.0361C13.5204 19.6307 13.9969 20.128 14.5781 20.4736C15.1594 20.8193 15.8237 21.0008 16.5 21V22.5C15.5824 22.5005 14.6806 22.2605 13.8848 21.8037C13.0889 21.3468 12.4261 20.6892 11.9639 19.8965C11.5016 19.1037 11.2556 18.2029 11.25 17.2852C11.2444 16.3675 11.4801 15.4644 11.9326 14.666C12.3851 13.8677 13.0389 13.202 13.8291 12.7354C14.6193 12.2687 15.5179 12.0176 16.4355 12.0068ZM15 1.5C15.3978 1.5 15.7792 1.65815 16.0605 1.93945C16.3419 2.22076 16.5 2.60218 16.5 3V9H3V13.5H9V15H3V19.5H9V21H3C2.60218 21 2.22076 20.8419 1.93945 20.5605C1.65815 20.2792 1.5 19.8978 1.5 19.5V3C1.5 2.60218 1.65815 2.22076 1.93945 1.93945C2.22076 1.65815 2.60218 1.5 3 1.5H15ZM5.25 16.5C5.66421 16.5 6 16.8358 6 17.25C6 17.6642 5.66421 18 5.25 18C4.83579 18 4.5 17.6642 4.5 17.25C4.5 16.8358 4.83579 16.5 5.25 16.5ZM5.25 10.5C5.66421 10.5 6 10.8358 6 11.25C6 11.6642 5.66421 12 5.25 12C4.83579 12 4.5 11.6642 4.5 11.25C4.5 10.8358 4.83579 10.5 5.25 10.5ZM3 7.5H15V3H3V7.5ZM5.25 4.5C5.66421 4.5 6 4.83579 6 5.25C6 5.66421 5.66421 6 5.25 6C4.83579 6 4.5 5.66421 4.5 5.25C4.5 4.83579 4.83579 4.5 5.25 4.5Z"
						fill="#00203C"
					/>
				</svg>
			</div>

			<div className="refresh-notice__text">
				<div className="refresh-notice__title">New data available</div>
				<div className="refresh-notice__subtitle">Refresh to see the latest updates.</div>
			</div>

			<div>
				<button
					type="button"
					className="refresh-notice__btn"
					onClick={onRefresh}
					disabled={disabled}
				>
					<span>Refresh</span>
					<svg
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M13.2733 10.3399H10.2533C10.0764 10.3399 9.90687 10.4102 9.78185 10.5352C9.65682 10.6602 9.58658 10.8298 9.58658 11.0066C9.58658 11.1834 9.65682 11.353 9.78185 11.478C9.90687 11.603 10.0764 11.6733 10.2533 11.6733H11.8533C11.1179 12.4417 10.1695 12.9728 9.13003 13.1982C8.09053 13.4236 7.00739 13.333 6.01977 12.9381C5.03215 12.5432 4.18516 11.862 3.58765 10.982C2.99013 10.1021 2.66937 9.06356 2.66659 7.99992C2.66659 7.82311 2.59635 7.65354 2.47132 7.52851C2.3463 7.40349 2.17673 7.33325 1.99992 7.33325C1.82311 7.33325 1.65354 7.40349 1.52851 7.52851C1.40349 7.65354 1.33325 7.82311 1.33325 7.99992C1.33678 9.30178 1.7214 10.5741 2.43965 11.6599C3.15791 12.7457 4.17836 13.5975 5.37508 14.1101C6.5718 14.6226 7.89241 14.7736 9.17393 14.5443C10.4555 14.3151 11.6418 13.7156 12.5866 12.8199V13.9999C12.5866 14.1767 12.6568 14.3463 12.7818 14.4713C12.9069 14.5963 13.0764 14.6666 13.2533 14.6666C13.4301 14.6666 13.5996 14.5963 13.7247 14.4713C13.8497 14.3463 13.9199 14.1767 13.9199 13.9999V10.9999C13.9183 10.8277 13.85 10.6628 13.7295 10.5397C13.6089 10.4167 13.4454 10.3451 13.2733 10.3399ZM7.99992 1.33325C6.29084 1.33813 4.64891 1.99919 3.41325 3.17992V1.99992C3.41325 1.82311 3.34301 1.65354 3.21799 1.52851C3.09297 1.40349 2.9234 1.33325 2.74659 1.33325C2.56977 1.33325 2.40021 1.40349 2.27518 1.52851C2.15016 1.65354 2.07992 1.82311 2.07992 1.99992V4.99992C2.07992 5.17673 2.15016 5.3463 2.27518 5.47132C2.40021 5.59635 2.56977 5.66659 2.74659 5.66659H5.74658C5.9234 5.66659 6.09297 5.59635 6.21799 5.47132C6.34301 5.3463 6.41325 5.17673 6.41325 4.99992C6.41325 4.82311 6.34301 4.65354 6.21799 4.52851C6.09297 4.40349 5.9234 4.33325 5.74658 4.33325H4.14658C4.88156 3.56517 5.82931 3.03425 6.86818 2.80866C7.90706 2.58306 8.98964 2.67308 9.97699 3.06716C10.9643 3.46124 11.8114 4.14139 12.4094 5.02032C13.0074 5.89925 13.3291 6.93684 13.3333 7.99992C13.3333 8.17673 13.4035 8.3463 13.5285 8.47132C13.6535 8.59635 13.8231 8.66658 13.9999 8.66658C14.1767 8.66658 14.3463 8.59635 14.4713 8.47132C14.5963 8.3463 14.6666 8.17673 14.6666 7.99992C14.6666 7.12444 14.4941 6.25753 14.1591 5.4487C13.8241 4.63986 13.333 3.90493 12.714 3.28587C12.0949 2.66682 11.36 2.17575 10.5511 1.84072C9.7423 1.50569 8.8754 1.33325 7.99992 1.33325Z"
							fill="#F1F5F8"
						/>
					</svg>
				</button>
			</div>
		</div>
	);
};

const TimelineUpdatedToast = ({ fromUnix, toUnix, style }) => {
	const from = dayjs.unix(fromUnix).format('HH:mm');
	const to = dayjs.unix(toUnix).format('HH:mm');

	return (
		<div className="timeline-toast" style={style} role="status" aria-live="polite">
			<div className="timeline-toast-svg">
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M21.85 13.5L19.8506 11.5L17.85 13.5M20.15 12C20.15 16.9706 16.1206 21 11.15 21C6.17946 21 2.15002 16.9706 2.15002 12C2.15002 7.02944 6.17946 3 11.15 3C14.4519 3 17.3385 4.77814 18.9045 7.42909M11.15 7V12L14.15 14"
						stroke="#535662"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</div>
			<span>
				Timeline updated from {from} to {to}
			</span>
		</div>
	);
};

const CatchmentView = ({ marginTop = '0px' }) => {
	const { value: context } = useContext(DashboardContext);
	const {
		decisionEngine: { setSelectedAssetItem, showComparisonGraph },
	} = useContext(NWLContext);

	const rawActive = useActiveLocationId();
	const activeLocationId =
		rawActive && rawActive !== 'undefined' && rawActive !== 'null' && rawActive !== ''
			? rawActive
			: null;

	const selectedLocationId = activeLocationId ?? context?.selectedLocation ?? null;

	const navigate = useNavigate();

	const [mapViewState, setMapViewState] = useState(DEFAULT_VIEW_STATE);
	const [infrastructure, setInfrastructure] = useState(null);
	const [primaryMapAssets, setPrimaryMapAssets] = useState(null);
	const [allMapAssets, setAllMapAssets] = useState(null);
	const [links, setLinks] = useState(null);
	const [timeBarSelection, setTimeBarSelection] = useState(dayjs().unix());
	const [locationOptions, setLocationOptions] = useState([]);
	const [showIconLegendModal, setShowIconLegendModal] = useState(false);
	const [isPlaying, setIsPlaying] = useState(false);
	const refreshPendingRef = useRef(false);
	const playBarUtilsRef = useRef();
	const [mapInitialLoading, setMapInitialLoading] = useState(true);
	const [sites, setSites] = useState([]);
	const [impactMarkers, setImpactMarkers] = useState([]);
	const [predictedImpacts, setPredictedImpacts] = useState(new Map());
	const [isDefault, setIsDefault] = useState(true);
	const isPlayingRef = useRef(false);
	const isDefaultRef = useRef(true);
	const [multiImpactAssets, setMultiImpactAssets] = useState([]);
	const prevShowComparisonGraphRef = useRef(showComparisonGraph);
	const layoutRef = useRef(null);

	const [showRefreshNotice, setShowRefreshNotice] = useState(false);
	const [isRefreshingNow, setIsRefreshingNow] = useState(false);
	const [refreshNoticeKey, setRefreshNoticeKey] = useState(0);
	const refreshNoticeShownRef = useRef(false);

	const [layerState, setLayerState] = useState(defaultLayerState);
	const showWeatherOverlay = layerState.rainfall;

	const showRefreshNoticeOnce = useCallback(() => {
		if (refreshNoticeShownRef.current) return;

		refreshNoticeShownRef.current = true;
		setShowRefreshNotice(true);
		setRefreshNoticeKey((k) => k + 1);
	}, []);

	const getToastStyleAbovePlayhead = useCallback(() => {
		const container = layoutRef.current;
		const rect = playBarUtilsRef.current?.getPlayheadRect?.();

		if (!container || !rect) return undefined;

		const c = container.getBoundingClientRect();

		const left = rect.left - c.left + rect.width / 2;
		const top = rect.top - c.top;

		return {
			left: `${left}px`,
			top: `${top}px`,
			bottom: 'auto',
			transform: 'translate(-50%, -120%)',
		};
	}, []);

	const timeBarSelectionRef = useRef(timeBarSelection);

	useEffect(() => {
		timeBarSelectionRef.current = timeBarSelection;
	}, [timeBarSelection]);

	const [timelineToast, setTimelineToast] = useState(null);
	const toastTimeoutRef = useRef(null);
	const lastDataFetchUnixRef = useRef(dayjs().unix());

	const showTimelineToast = useCallback((fromUnix, toUnix, style) => {
		setTimelineToast({ fromUnix, toUnix, style });

		if (toastTimeoutRef.current) window.clearTimeout(toastTimeoutRef.current);
		toastTimeoutRef.current = window.setTimeout(() => setTimelineToast(null), 5000);
	}, []);

	useEffect(() => {
		window.dispatchEvent(
			new CustomEvent('nwl:timeline-default-changed', { detail: { isDefault } }),
		);
	}, [isDefault]);

	const PLAYBAR_SNAP_SECONDS = 60;
	const snapNearest = useCallback((unix, stepSeconds = PLAYBAR_SNAP_SECONDS) => {
		const u = Number(unix);
		if (!Number.isFinite(u)) return u;
		return Math.floor(u / stepSeconds) * stepSeconds;
	}, []);

	const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

	const animatePlayBarTo = useCallback((targetUnix, durationMs = 650) => {
		const fromUnix = Number(timeBarSelectionRef.current ?? targetUnix);
		const toUnix = Number(targetUnix);

		if (!Number.isFinite(fromUnix) || !Number.isFinite(toUnix)) return Promise.resolve();

		if (fromUnix === toUnix) {
			playBarUtilsRef.current?.setPlayBarValue?.(toUnix);
			return Promise.resolve();
		}

		return new Promise((resolve) => {
			const start = performance.now();
			const diff = toUnix - fromUnix;

			const tick = (now) => {
				const t = Math.min(1, (now - start) / durationMs);
				const eased = easeInOutCubic(t);
				const current = Math.round(fromUnix + diff * eased);

				playBarUtilsRef.current?.setPlayBarValue?.(current);

				if (t < 1) {
					requestAnimationFrame(tick);
				} else {
					playBarUtilsRef.current?.setPlayBarValue?.(toUnix);
					resolve();
				}
			};

			requestAnimationFrame(tick);
		});
	}, []);

	const markRefreshPending = useCallback(() => {
		if (refreshPendingRef.current) return;
		refreshPendingRef.current = true;

		if (!isDefaultRef.current) {
			showRefreshNoticeOnce();
		}
	}, [showRefreshNoticeOnce]);

	const clearRefreshPending = useCallback(() => {
		refreshPendingRef.current = false;
		refreshNoticeShownRef.current = false;
		setShowRefreshNotice(false);
	}, []);

	useEffect(() => {
		if (isDefault) {
			clearRefreshPending();
			return;
		}

		if (refreshPendingRef.current) {
			showRefreshNoticeOnce();
		}
	}, [isDefault, showRefreshNoticeOnce, clearRefreshPending]);

	const toLayerKey = (raw) => {
		if (!raw) return '';
		const lower = String(raw).trim().toLowerCase();
		const spaced = lower.replace(/_/g, ' ');
		if (spaced === 'rain gauge') return 'rain gauge';
		return spaced;
	};

	const ensureLayerKeysFromAssets = (assets, prevState) => {
		const next = {
			anomaly: true,
			blockage: true,
			pumpAlert: true,
			rainfall: true,
			...(prevState || {}),
		};

		if (!Array.isArray(assets)) return next;

		for (const a of assets) {
			const raw = a?.infrastructureTypeName ?? a?.type;
			if (!raw) continue;

			const key = toLayerKey(raw);
			if (!key) continue;

			if (!(key in next)) {
				next[key] = key === 'rain gauge' ? false : true;
			}
		}

		return next;
	};

	const toPrimaryMapAssets = (assets) => {
		if (!Array.isArray(assets)) return null;

		return assets
			.map((asset) => {
				const primaryParameters = (asset.parameters || []).filter((p) => p?.config?.isPrimary);

				if (!primaryParameters.length) {
					return null;
				}

				return {
					...asset,
					parameters: primaryParameters,
				};
			})
			.filter(Boolean);
	};

	useEffect(() => {
		const sync = () => {
			const locations = JSON.parse(localStorage.getItem('locations') ?? '[]');

			const opts = (Array.isArray(locations) ? locations : []).map((location) => ({
				value: String(location.locationId),
				displayText: `${location.locationName}`,
			}));
			setLocationOptions(opts);
		};

		sync();
		window.addEventListener('nwl:locations-updated', sync);
		window.addEventListener('storage', sync);
		return () => {
			window.removeEventListener('nwl:locations-updated', sync);
			window.removeEventListener('storage', sync);
		};
	}, []);

	useEffect(() => {
		if (!locationOptions.length) return;

		if (activeLocationId == null) {
			setActiveLocationId(locationOptions[0]?.value ?? null);
		}
	}, [locationOptions, activeLocationId]);

	// Fetch map data
	const fetchMapData = useCallback(async () => {
		if (!selectedLocationId) return;

		const now = dayjs();
		const start = now.subtract(24, 'hour').unix();
		const end = now.unix();

		let ok = false;

		try {
			const security = localStorage.getItem('security');
			const organizationId = JSON.parse(security ?? '{}')?.organizationId;
			const locId = Number(selectedLocationId);
			if (!Number.isFinite(locId)) return;

			const infrasResult = await getInfraestructuresByLocation(locId);
			const getAllMapAssetsInfo = await getMapAssets(organizationId, locId, start, end, false);
			const sitesResult = await getSites(organizationId);
			const linksResultMinify = await getLinksMinify(locId);

			if (infrasResult) setInfrastructure(infrasResult);

			if (getAllMapAssetsInfo) {
				setAllMapAssets(getAllMapAssetsInfo);

				const primaryAssets = toPrimaryMapAssets(getAllMapAssetsInfo);
				setPrimaryMapAssets(primaryAssets);

				setLayerState((prev) => ensureLayerKeysFromAssets(primaryAssets, prev));
			}

			if (Array.isArray(sitesResult)) setSites(sitesResult);
			if (linksResultMinify) setLinks(linksResultMinify);

			ok = true;
		} finally {
			setMapInitialLoading(false);
			if (ok) lastDataFetchUnixRef.current = end;
		}
	}, [selectedLocationId]);

	useEffect(() => {
		let cancelled = false;

		const run = async () => {
			const security = localStorage.getItem('security');
			const organizationId = JSON.parse(security ?? '{}')?.organizationId;

			if (!selectedLocationId && !organizationId) return;

			const locId = Number(selectedLocationId);
			if (!Number.isFinite(locId)) return;

			const coordsResult = await getLocationCoords(organizationId, locId);
			if (cancelled) return;

			const lon = Number(coordsResult?.longitude);
			const lat = Number(coordsResult?.latitude);
			const zoom = Number(coordsResult?.zoomLevel ?? DEFAULT_VIEW_STATE.zoom);

			if (!Number.isFinite(lon) || !Number.isFinite(lat) || !Number.isFinite(zoom)) return;

			setMapViewState((prev) => ({
				...(prev ?? DEFAULT_VIEW_STATE),
				longitude: lon,
				latitude: lat,
				zoom,
			}));
		};

		void run();
		return () => {
			cancelled = true;
		};
	}, [selectedLocationId]);

	useEffect(() => {
		setMapInitialLoading(true);
		void fetchMapData();
	}, [fetchMapData]);

	const performSilentRefresh = useCallback(async () => {
		if (showComparisonGraph) return;
		const now = dayjs().unix();
		const end = dayjs().add(12, 'hour').unix();

		playBarUtilsRef.current?.setStartTimeValue(now);
		playBarUtilsRef.current?.setPlayBarValue(now);
		playBarUtilsRef.current?.setEndTimeValue(end);

		await fetchMapData();
	}, [fetchMapData, showComparisonGraph]);

	const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

	const handleManualRefresh = useCallback(async () => {
		if (isRefreshingNow) return;
		if (showComparisonGraph) return;

		setIsRefreshingNow(true);

		const fromUnix = Number(timeBarSelectionRef.current ?? dayjs().unix());

		try {
			clearRefreshPending();

			const nowUnix = dayjs().unix();
			const lastFetchUnix = Number(lastDataFetchUnixRef.current ?? nowUnix);

			const newStartUnix = snapNearest(nowUnix); 
			const newEndUnix = newStartUnix + 12 * 60 * 60;

			const delta = Math.max(0, newStartUnix - lastFetchUnix);

			const shiftedUnix = fromUnix + delta;

			const rawTarget = snapNearest(shiftedUnix);
			const toUnix = clamp(rawTarget, newStartUnix, newEndUnix);

			await fetchMapData();

			window.dispatchEvent(new CustomEvent('nwl:timeline-manual-refresh'));

			playBarUtilsRef.current?.setStartTimeValue?.(newStartUnix);
			playBarUtilsRef.current?.setEndTimeValue?.(newEndUnix);

			await animatePlayBarTo(toUnix, 650);

			requestAnimationFrame(() => {
				const style = getToastStyleAbovePlayhead();
				if (toUnix !== fromUnix) showTimelineToast(fromUnix, toUnix, style);
			});
		} finally {
			setIsRefreshingNow(false);
		}
	}, [
		isRefreshingNow,
		showComparisonGraph,
		clearRefreshPending,
		fetchMapData,
		snapNearest,
		animatePlayBarTo,
		showTimelineToast,
		getToastStyleAbovePlayhead,
	]);

	useEffect(() => {
		const prev = prevShowComparisonGraphRef.current;

		if (prev && !showComparisonGraph) {
			if (isDefaultRef.current && !isPlayingRef.current) {
				clearRefreshPending();
				void performSilentRefresh();
			} else {
				markRefreshPending();
			}
		}

		prevShowComparisonGraphRef.current = showComparisonGraph;
	}, [showComparisonGraph, performSilentRefresh, markRefreshPending, clearRefreshPending]);

	useEffect(() => {
		const buildImpactsIndex = (payload) => {
			if (!Array.isArray(payload)) {
				return { index: new Map(), assetMultiImpact: [] };
			}

			const index = new Map();
			const multiSet = new Set();

			payload.forEach((asset) => {
				const impacts = asset.parameters
					.flatMap((p) => (p.impacts || []).map((i) => [i.startTime, i.endTime]))
					.sort((a, b) => a[0] - b[0]);

				const risks = asset.parameters
					.flatMap((p) => (p.risks || []).map((r) => [r.startTime, r.endTime]))
					.sort((a, b) => a[0] - b[0]);

				index.set(asset.id, { risks, impacts });

				if (impacts.length > 1) {
					multiSet.add(asset.name);
				}
			});

			return { index, assetMultiImpact: Array.from(multiSet) };
		};

		const indexHandler = (e) => {
			const payload = Array.isArray(e?.detail) ? e.detail : [];
			const { index, assetMultiImpact } = buildImpactsIndex(payload);

			setPredictedImpacts(index);
			setMultiImpactAssets(assetMultiImpact);
		};

		window.addEventListener('nwl:impacted-forecast', indexHandler);
		return () => window.removeEventListener('nwl:impacted-forecast', indexHandler);
	}, []);

	useEffect(() => {
		const toMarkers = (payload) => {
			if (!Array.isArray(payload)) return [];

			const multiSet = new Set(multiImpactAssets);

			return payload
				.map((bucket) => {
					const impacts = bucket.impacts || [];

					if (!impacts.length) return null;

					const items = impacts.map((imp) => {
						const isMulti = multiSet.has(imp.name);
						return {
							startTime: imp.start,
							endTime: imp.end,
							label: isMulti
								? `${imp.name} is impacted multiple times from this point.`
								: `${imp.name} impacted`,
						};
					});

					return {
						time: bucket.start,
						items,
					};
				})
				.filter(Boolean);
		};

		const markerHandler = (e) => {
			const payload = Array.isArray(e?.detail) ? e.detail : [];
			const markers = toMarkers(payload);
			setImpactMarkers(markers);
		};
		window.addEventListener('nwl:impacted-forecast-timeline', markerHandler);
		return () => window.removeEventListener('nwl:impacted-forecast-timeline', markerHandler);
	}, [multiImpactAssets]);

	useEffect(() => {
		const handler = () => {
			setSelectedAssetItem(null);
			setShowIconLegendModal(false);
		};
		window.addEventListener('nwl:close-all-modals', handler);
		return () => window.removeEventListener('nwl:close-all-modals', handler);
	}, [setSelectedAssetItem, setShowIconLegendModal]);

	useEffect(() => {
		if (process.env.VITE_APP_ENV === 'prod') return;
		window.setMapView = setMapViewState; //  expose to Cypress for testing
	}, [setMapViewState, mapViewState]);

	useEffect(() => {
		if (showComparisonGraph) return;
		if (isDefault && !isPlaying && refreshPendingRef.current) {
			clearRefreshPending();
			performSilentRefresh();
		}
	}, [isDefault, isPlaying, performSilentRefresh, showComparisonGraph, clearRefreshPending]);

	// Periodic refresh - runs every 60 seconds when in default state and not playing
	useEffect(() => {
		if (showComparisonGraph) return;
		if (showRefreshNotice || isRefreshingNow) return;

		const intervalId = setInterval(async () => {
			if (showComparisonGraph) return;
			if (refreshPendingRef.current || showRefreshNotice || isRefreshingNow) return;

			if (isDefaultRef.current && !isPlayingRef.current) {
				await performSilentRefresh();
			} else {
				markRefreshPending();
			}
		}, 60000);

		return () => window.clearInterval(intervalId);
	}, [performSilentRefresh, showComparisonGraph, markRefreshPending, showRefreshNotice, isRefreshingNow]);

	useEffect(() => {
		const onFocus = (e) => {
			const lon = Number(e?.detail?.longitude);
			const lat = Number(e?.detail?.latitude);
			const zoom = Number(e?.detail?.zoom ?? 18);

			if (!Number.isFinite(lon) || !Number.isFinite(lat)) return;

			setMapViewState((prev) => ({
				...(prev ?? DEFAULT_VIEW_STATE),
				longitude: lon,
				latitude: lat,
				zoom: Number.isFinite(zoom) ? zoom : (prev?.zoom ?? 18),

				transitionDuration: 2000,
				transitionInterpolator: new FlyToInterpolator(),
				transitionEasing: (t) => t, 
			}));
		};

		window.addEventListener('nwl:map-focus', onFocus);
		return () => window.removeEventListener('nwl:map-focus', onFocus);
	}, []);

	return (
		<div className="dashboard" style={{ marginTop, height: `calc(100vh - ${marginTop})` }}>
			{weatherOverlayKey && (
				<RainRate keyMapping={weatherOverlayKey} defaultShowOverlay={layerState.rainfall} />
			)}
			<AssetInfo />
			<ComparisonGraph assets={infrastructure} allMapAssets={allMapAssets} />
			<Navbar
				locationOptions={locationOptions}
				activeLocation={activeLocationId}
				onLocationChange={(id) => setActiveLocationId(id)}
				onBack={() => navigate('/nwl')}
				layerState={layerState}
				onLayerStateChange={setLayerState}
			/>
			<ControlZoom viewState={mapViewState} setViewState={setMapViewState} />
			<IconLegend
				showIconLegendModal={showIconLegendModal}
				setShowIconLegendModal={setShowIconLegendModal}
			/>
			<div ref={layoutRef} className="layout" style={{ position: 'relative' }}>
				{mapInitialLoading && (
					<div className="map-initial-loader">
						<div className="map-initial-loader__panel">
							<div className="map-initial-loader__spinner" aria-hidden="true" />
						</div>
					</div>
				)}
				<div className="map1 map">
					<NWLMap
						viewState={mapViewState}
						setViewState={setMapViewState}
						infrastructure={primaryMapAssets}
						links={links}
						sites={sites}
						timeBarSelection={timeBarSelection}
						showWeatherOverlay={showWeatherOverlay}
						weatherOverlayKey={weatherOverlayKey}
						onItemSelected={setSelectedAssetItem}
						predictedImpacts={predictedImpacts}
						isDefault={isDefault}
						layerState={layerState}
						activeLocation={selectedLocationId}
					/>
					<Kpi kpiIndex={0} strategyOnChange={undefined} displayColumn={false} />
				</div>
				{showRefreshNotice && !showComparisonGraph && !isDefault && (
					<RefreshNotice
						key={refreshNoticeKey}
						onRefresh={handleManualRefresh}
						disabled={isRefreshingNow}
					/>
				)}
				{timelineToast && (
					<TimelineUpdatedToast 
						fromUnix={timelineToast.fromUnix} 
						toUnix={timelineToast.toUnix} 
						style={timelineToast.style}
					/>
				)}
				<PlayBar
					position="bottom"
					stepsPerSecond={0.25}
					onPlayBarValueStateChange={(playBarValue) => setTimeBarSelection(playBarValue)}
					onDefaultStateChange={(isDefault) => {
						setIsDefault(isDefault);
						isDefaultRef.current = isDefault;
					}}
					onPlayStateChange={(playing) => {
						setIsPlaying(playing);
						isPlayingRef.current = playing;
					}}
					externalSetValue={(utils) => (playBarUtilsRef.current = utils)}
					markers={impactMarkers}
				/>
			</div>
		</div>
	);
};

export default CatchmentView;
